const Form102EN = {
    stepName: {
        importantNotes: "Important Notes",
        organization: "Organization",
        owner: "Owner/Operator",
        contactPerson: "Contact Person",
        proposedCourse: "Proposed course/lecture",
        teacher: "Teacher(s) / Speaker(s)",
        attachments: "Attachments",
        declaration: "Declaration by owner / operator",
        confirmation: "Confirmation",
    },
    label: {
        organization: "Organization",
        enOrganization: "English name of the organization",
        cnOrganization: "Chinese name of the organization",
        tel: "Telephone No.",
        fax: "Fax No.",
        enAddress: "English Address",
        cnAddress: "Chinese Address",
        making: "Non-profit making",
        makingOptions: {
            yes: "Yes",
            no: "No",
        },
        makingYes:
            "If yes, please attach document (e.g. letter from Inland Revenue Department) giving evidence that the organization is a non-profit- making charitable incorporated body.",
        backgroundAndService: "Background and Service",
        attach: "Please attach detailed information.",
        title: "Title",
        enName: "English Name",
        cnName: "Chinese Name",
        hkid: "ID Card No.",
        enTitleOptions: {
            mr: "Mr",
            mrs: "Mrs",
            miss: "Miss",
            ms: "Ms",
        },
        cnTitleOptions: {
            mr: "先生",
            mrs: "太太",
            miss: "小姐",
            ms: "女士",
        },
        contactNote: "<i>(The Education Bureau will send the application result and related documents to the <b>'Contact Person'</b> by post upon completion of the application assessment.)</i>",
        contactSurname: "Surname",
        contactOtherName: "Other names",
        contactEmail: "Email Address",
        contactAddress: "Correspondence Address",
        briefDescription: "Brief Description",
        proposedCourseTitle: "Title",
        relevantInformation: "Please attach relevant information.",
        targetParticipants: "Target Participants",
        fees: "Fees (HKD)",
        proposedPeriod: "Proposed Period of Exemption(not exceeding one year)",
        dateFrom: "Proposed Period of Exemption(not exceeding one year) from",
        dateTo: "to",
        otherDetails: "Other Details",
        centreName: "Centre Name",
        venue: "Venue",
        time: "Time (Please specify the number of days per week and time, e.g. Every Mon to Fri from 2:00 pm to 6:00 pm)",
        providingAcademic:
            "Time of providing academic instruction (Please specify the number of days per week and time, e.g. Every Mon to Fri from 3:00 pm to 4:45 pm, includes 10 minutes break)",
        timeRemark: "Remarks: (e.g. includes 10 minutes break)",
        estimatedEnrolment: "Estimated Enrolment",
        additionalSheet: "Please add additional sheet if required.",
        occupation: "Occupation",
        qualification: "Qualification",
        iAttach: "I attach",
        lectureContents: "Information/contents of the proposed course/lecture",
        informationOrganization: "Information of my organization",
        copies: "Copies of certificate(s) / diploma(s) of academic qualification(s), teacher registration certificate(s) / teaching permit(s) of teacher(s) / speaker(s) (I have certified original seen on each copy)",
        others: "Others",
        i: "I ",
        criminalOffenceOp: {
            yes: "have",
            no: "have not",
        },
        criminalOffence: "been convicted of a /any criminal offence;",
        declare:
            "I declare that the contents of this application are true and complete to the best of my knowledge and belief.",
    },
    errorMsg: {
        notExceedingOneYear:
            "Please select a period of time not exceeding one year from today's date",
        ownerTitleEn: "Please select the same title as in Chinese",
        ownerTitleCn: "Please select the same title as in English",
    },
    dialog: {
        title: "Note",
        content:
            "Please print and manually sign on the completed application form.  The signed application form should be sent to the School Registration and Compliance Section of Education Bureau (Office address:  28/F, E-Trade Plaza, 24 Lee Chung Street, Chai Wan, Hong Kong). EDB will process your application upon receiving the signed application form.",
        successfulFormSubmission:
            "Successful Form Submission to Organization Approver",
        successfulSubmissionMsgToA:
            "You have successfully submitted the form to the approver of your organization. Please remind the organization approver to sign and submit the application form to EDB.",
        notice: "Notice: This form has not been submitted to EDB yet.  Please sign and submit the form.",
        approveNotice:
            "Notice: An application is received. Pending EDB to approve and grant the exemption order.",
        receiveNotice: "Notice: An application is received. Please process.",
        submittedCannotEdited:
            "The form will be submitted and cannot be edited anymore.",
        successfulSubmissionMsg2:
            "An email of confirmation has been sent to your registered email address.",
    },
};
export default Form102EN;
